import React from "react"

const riya_kulkarni = () => {
    return (
        <div>
<h1>Riya Kulkarni</h1>

<h4><em>Computer Engineering, Batch of 27'<br/><hr/></em></h4>

<p><strong>What was the criteria for shortlisting candidates in the initial stages of the recruitment process</strong>?<br />
CGPA - 7+ and branch was restricted to Computer.</p>

<p><strong>What was the Timeline of the entire Interview Process</strong>?<br />
First we had the PPT, soon after which we were seated to give the aptitude test. Interviews began the next day at 9 AM, finishing up 2 Technical Interviews and 1 HR interview by around 2. The results were announced at 6 PM the same day. Very less room for anxiety :)</p>

<p><strong>What was the Structure of the Aptitude Round?</strong><br />
There were 2 DSA questions that took 90 % of the time.<br />
Both questions were graph traversal questions.<br />
1 - Easy-Medium, 2 - Medium (Hard with reduced time complexity).</p>

<p><strong>How many students were shortlisted after the Aptitude Round?</strong><br />
22</p>

<p><strong>After being shortlisted, how long was the wait time before the interviews began? During this period, what specific areas did you focus on to prepare effectively?</strong><br />
We got the shortlist at around 11 PM on the day of the test.<br />
I practiced my introduction lines a few times and answers to common behavioural questions before getting a good night’s sleep. Not sure if it helped, but it boosted my confidence.</p>

<p><strong>How many Interview Rounds were there for the company, can you elaborate about each round in brief? Also mention, how many students were shortlisted after each Interview Round?</strong><br />
3 rounds - </p>

<ol>
<li>Technical round 1:<br />
Topics - Java (Difference between JVM JRE, Spring Spring boot, IoC etc), React (Explain what is a nodejs environment etc), and one puzzle. The topics really depends on the specialization of the interviewer as I was not asked all that was highlighted on my resume.<br />
Duration - 30 mins  </li>
<li>Technical round 2:<br />
Topics - Computer Networks, DBMS, Java. I was not asked any DSA though.<br />
One lengthy puzzle that required probability computation, Bayes’ theorem.<br />
The entire interview was like an engaging conversation, continuous reasoning and follow up questions to all of my answers.<br />
Duration - 40-50 mins  </li>
<li>HR round:<br />
Questions asked (which I can recollect) - a. Why are you joining DB, is it because it is just a company that has come for the campus drive? b. How do you work in a team, describe your attributes. c. If there was another company that shared the same mission and vision as DB, provided the same incentives, how would you make a decision between the two companies?<br />
Duration - 20-30 mins</li>
</ol>

<p><strong>What are some good resources that you used in your Internship Prep?</strong><br />
DSA - <a href="https://neetcode.io/roadmap">https://neetcode.io/roadmap</a><br />
DBMS - <a href="https://youtu.be/YRnjGeQbsHQ?si=SF_HSwmr0VkoGCfS%20">KnowledgeGate</a><br />
OS - <a href="https://www.youtube.com/playlist?list=PLxCzCOWd7aiGz9donHRrE9I3Mwn6XdP8p">Gate Smashers</a> (Major topics)<br />
DP - <a href="https://www.youtube.com/playlist?list=PL_z_8CaSLPWekqhdCPmFohncHwz8TY2Go">Aditya Verma</a><br />
Java and OOP - Java McGrawHill Herbert Schildt book</p>

<p><strong>Some tips to crack Coding Questions?</strong><br />
Practice. Watch videos that walk you through solving a problem.</p>

<p><strong>How many questions were asked about Projects, Clubs, and Extracurricular activities in your resume</strong>?<br />
Questions were asked about projects and tech stack, and then a brief question about why these technologies were chosen.<br />
My involvement in clubs and extracurricular activities was not directly questioned, but such experiences can be valuable during behavioural rounds, as they provide practical contexts to support your answers. More than that though, well-reasoned responses can convey strong analytical and interpersonal skills just as effectively.</p>

<p><strong>Any Final Tips for Juniors?</strong><br />
Stay consistent and have a routine. A friend who will follow through with you is a blessing. Everyone is running the same race here, and we’ve been there before haven’t we :).</p>

<p><strong>Contact Info (these will be shared in the diary, you are free to not share any specific one)</strong><br />
<strong>Email :</strong> <a href="mailto:riyaak23.comp@coeptech.ac.in">riyaak23.comp@coeptech.ac.in</a><br />
<strong>LinkedIn :</strong> <a href="http://www.linkedin.com/in/riya-ashutosh-kulkarni">Riya Kulkarni</a></p>

<hr />

        </div>
    )
}

export default riya_kulkarni
